import Header from '../components/Header';
import Footer from '../components/Footer';

export default function Terms() {
    return (
        <div className="page">
            <Header />
            <div className="container" style={{ padding: '48px 24px', maxWidth: 800 }}>
                <h1>Regulamin</h1>
                <p className="text-muted mt-sm">Ostatnia aktualizacja: marzec 2026</p>

                <div className="glass mt-lg" style={{ padding: '32px' }}>
                    <h2 style={{ fontSize: '1.3rem', marginBottom: '16px' }}>1. Postanowienia ogólne</h2>
                    <p style={{ color: 'var(--color-text-secondary)', lineHeight: 1.8 }}>
                        PickOneGift jest bezpłatną usługą umożliwiającą tworzenie list prezentów
                        i udostępnianie ich znajomym za pomocą unikalnych linków. Korzystanie
                        z usługi oznacza akceptację niniejszego regulaminu.
                    </p>

                    <h2 style={{ fontSize: '1.3rem', margin: '24px 0 16px' }}>2. Zasady korzystania</h2>
                    <ul style={{ color: 'var(--color-text-secondary)', lineHeight: 1.8, paddingLeft: '20px' }}>
                        <li>Użytkownik zobowiązuje się do podawania prawdziwych danych kontaktowych.</li>
                        <li>Zabrania się wykorzystywania usługi do celów niezgodnych z prawem.</li>
                        <li>Zabrania się dodawania treści obraźliwych, obscenicznych lub naruszających prawa osób trzecich.</li>
                        <li>Każda lista może zawierać od 2 do 20 prezentów.</li>
                    </ul>

                    <h2 style={{ fontSize: '1.3rem', margin: '24px 0 16px' }}>3. Odpowiedzialność</h2>
                    <p style={{ color: 'var(--color-text-secondary)', lineHeight: 1.8 }}>
                        PickOneGift nie ponosi odpowiedzialności za treści dodawane przez użytkowników,
                        w tym linki do produktów zewnętrznych. Nie pośredniczymy w zakupach ani
                        wysyłce prezentów — jedynie ułatwiamy wybór.
                    </p>

                    <h2 style={{ fontSize: '1.3rem', margin: '24px 0 16px' }}>4. Usunięcie danych</h2>
                    <p style={{ color: 'var(--color-text-secondary)', lineHeight: 1.8 }}>
                        Twórca listy może ją usunąć w dowolnym momencie, korzystając z tokenu
                        usunięcia otrzymanego przy tworzeniu listy. Po usunięciu lista zostaje
                        trwale oznaczona jako usunięta.
                    </p>

                    <h2 style={{ fontSize: '1.3rem', margin: '24px 0 16px' }}>5. Widget dla sklepów</h2>
                    <p style={{ color: 'var(--color-text-secondary)', lineHeight: 1.8 }}>
                        Sklepy mogą osadzać widget PickOneGift na swoich stronach po otrzymaniu
                        identyfikatora firmy (companyId). Widget działa w ramce iframe i
                        komunikuje się z główną aplikacją PickOneGift za pomocą bezpiecznego
                        protokołu postMessage.
                    </p>

                    <h2 style={{ fontSize: '1.3rem', margin: '24px 0 16px' }}>6. Zmiany regulaminu</h2>
                    <p style={{ color: 'var(--color-text-secondary)', lineHeight: 1.8 }}>
                        Zastrzegamy sobie prawo do zmiany niniejszego regulaminu. O istotnych
                        zmianach poinformujemy na stronie głównej.
                    </p>
                </div>
            </div>
            <Footer />
        </div>
    );
}
